'use strict';

module.exports = function ($stateProvider) {
    $stateProvider
    // NEW LOCAL IPS
    .state('pages.main.new_remote', {
        url: '/new_remote',
        template: require('../views/anomalies/new_remote.html'),
        controller: 'newRemoteController',
        controllerAs: 'page',
        data: {
            title: 'New Remote IP Addresses Detected',
            daterange: true
        }
    })
    // // NEW LOCAL IPS
    //     .state('pages.main.new_local_ip', {
    //         url: '/new_local_ip',
    //         template: require('../views/anomalies/new_local_ip.html'),
    //         controller: 'newLocalIpController',
    //         controllerAs: 'page',
    //         data: {
    //             title: 'New Local IPs Seen',
    //             daterange: true
    //         }
    //     })
    // // NEW LOCAL MAC
    //     .state('pages.main.new_local_mac', {
    //         url: '/new_local_mac',
    //         template: require('../views/anomalies/new_local_mac.html'),
    //         controller: 'newLocalMacController',
    //         controllerAs: 'page',
    //         data: {
    //             title: 'New Local MAC Addresses Seen',
    //             daterange: true
    //         }
    //     })
    // NEW DNS QUERIES
    .state('pages.main.new_dns_queries', {
        url: '/new_dns_queries',
        template: require('../views/anomalies/new_dns_queries.html'),
        controller: 'newDnsQueriesController',
        controllerAs: 'page',
        data: {
            title: 'New DNS Queries Detected',
            daterange: true
        }
    })
    // NEW HTTP HOSTS
    .state('pages.main.new_http_domains', {
        url: '/new_http_domains',
        template: require('../views/anomalies/new_http_domains.html'),
        controller: 'newHttpDomainsController',
        controllerAs: 'page',
        data: {
            title: 'New HTTP Domains Detected',
            daterange: true
        }
    })
    // NEW SSL HOSTS
    .state('pages.main.new_ssl_hosts', {
        url: '/new_ssl_hosts',
        template: require('../views/anomalies/new_ssl_hosts.html'),
        controller: 'newSslHostsController',
        controllerAs: 'page',
        data: {
            title: 'New SSL Server Names Detected',
            daterange: true
        }
    })
    // NEW SSH REMOTE IPS
    .state('pages.main.new_ssh_remote', {
        url: '/new_ssh_remote',
        template: require('../views/anomalies/new_ssh_remote.html'),
        controller: 'newSshRemoteController',
    controllerAs: 'page',
        data: {
            title: 'New Responder SSH Server/Client Detected',
            daterange: true
        }
    })
    // NEW FTP REMOTE IPS
    .state('pages.main.new_ftp_remote', {
        url: '/new_ftp_remote',
        template: require('../views/anomalies/new_ftp_remote.html'),
        controller: 'newFtpRemoteController',
        controllerAs: 'page',
        data: {
            title: 'New Responder FTP Server/Client Detected',
            daterange: true
        }
    })
}



/** WEBPACK FOOTER **
 ** ./src/pages/routes/anomalies.js
 **/